var Video = (function () {

    var $ = require('jquery');
    var self = {};

    self.$playButton = $('.play');
    self.$pauseButton = $('.pause');
    self.$video = $('video');

    self.init = function () {

        self.$video.on('ended', function () {

            self.$video
                .closest('figure')
                .removeClass('is-playing');

        });

        self.$playButton.on('click', function (ev) {
            ev.preventDefault();

            var $this = $(this);
            var $media = $this.closest('figure');

            $media.find('video')[0].play();

            $media.addClass('is-playing');
        });

        self.$pauseButton.on('click', function (ev) {
            ev.preventDefault();

            var $this = $(this);
            var $media = $this.closest('figure');

            $media.find('video')[0].pause();

            $media.removeClass('is-playing');
        });

    };

    return self;

}());

module.exports = Video;
